import React from 'react'
import PropTypes from 'prop-types'

const IconEdit = ({size = 24}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.293 2.293a3.828 3.828 0 1 1 5.414 5.414l-2.997 2.997-.003.003-.003.003L8.502 20.913l-.05.05c-.245.246-.46.462-.718.631-.225.149-.47.267-.727.35-.293.095-.597.128-.941.166l-.07.008-3.385.376a1 1 0 0 1-1.104-1.104l.376-3.385.008-.07c.038-.344.071-.648.166-.94a3 3 0 0 1 .35-.728c.17-.257.385-.473.63-.718l.05-.05L16.294 2.293ZM14 7.414l-9.5 9.5c-.322.322-.382.388-.425.454a1 1 0 0 0-.116.242c-.024.074-.039.163-.09.616l-.237 2.142 2.142-.238c.453-.05.542-.065.616-.089.086-.028.167-.067.242-.117.066-.043.132-.102.455-.425L16.586 10 14 7.414Zm4 1.172L15.414 6l2.293-2.293a1.828 1.828 0 0 1 2.586 2.586L18 8.586Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

IconEdit.propTypes = {
  size: PropTypes.number,
}

export default IconEdit
